import { MdOutlineFileUpload } from "react-icons/md";
import CustomButton from "@/components/customButton";
import { checkPermission } from "@/utils";

const UploadButton = ({
    role,
    createPermission,
    updatePermission,
    onClick,
    isLoading,
    className = "",
}) => {
    const canUpload =
        role !== "COMPANY_ADMIN" &&
        (checkPermission(createPermission) ||
            checkPermission(updatePermission));

    if (!canUpload) return null;

    return (
        <CustomButton
            isLoading={isLoading}
            onClick={onClick}
            btnName="Upload"
            customClasses={`shadow-md font-medium border py-1 px-6 !border-themeBorder ${className}`}
            iconPosition="left"
        >
            {/* <MdOutlineFileUpload
                size={20}
                className="text-black font-bold"
            /> */}
        </CustomButton>
    );
};

export default UploadButton;